import { Component, OnDestroy, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { AppConfigService } from 'src/app/shared/services/app-config.service';
import { DynamicTitleService } from 'src/app/shared/services/dynamic-title.service';
import { AccessibilityService } from 'src/app/shared/services/accessibility.service';

@Component({
  selector: 'app-root',
  templateUrl: './portal.component.html',
  styleUrls: ['./portal.component.scss'],
  standalone: false
})
export class PortalComponent implements OnInit, OnDestroy {
  private titleSubscription: Subscription;

  constructor(
    private dynamicTitleService: DynamicTitleService,
    private title: Title,
    appConfigService: AppConfigService,
    accessibilityService: AccessibilityService
  ) {
    //create the live region up front so screen readers register it on first buffer build
    accessibilityService.ensureLiveRegion();
    const tenantName = appConfigService.tenant.name ?? '';
    this.title.setTitle(`${tenantName} Portal`);
  }

  ngOnInit(): void {
    this.titleSubscription = this.dynamicTitleService.titleUpdated.subscribe((title: string) => {
      this.title.setTitle(title);
    });
  }

  ngOnDestroy(): void {
    this.titleSubscription?.unsubscribe();
  }
}
